module.exports = __webpack_public_path__ + "img/bird.1fe5a6af.svg";